import { render, staticRenderFns } from "./userYffz.vue?vue&type=template&id=84ae8df2&scoped=true&"
import script from "./userYffz.vue?vue&type=script&lang=js&"
export * from "./userYffz.vue?vue&type=script&lang=js&"
import style0 from "./userYffz.vue?vue&type=style&index=0&id=84ae8df2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ae8df2",
  null
  
)

export default component.exports